// Define a constant variable for changing the category
export const CHANGE_CATEGORY = "CHANGE_CATEGORY";

// Define a constant variable for changing the difficulty
export const CHANGE_DIFFICULTY = "CHANGE_DIFFICULTY";

// Define a constant variable for changing the question type
export const CHANGE_TYPE = "CHANGE_TYPE";

// Define a constant variable for changing the number of questions
export const CHANGE_AMOUNT = "CHANGE_AMOUNT";

// Define a constant variable for changing the user's score
export const CHANGE_SCORE = "CHANGE_SCORE";

// Define a constant variable for changing the total time used
export const CHANGE_TOTALTIME = "CHANGE_TOTALTIME";

// Define a constant variable for pause functionality
export const SET_GAME_PAUSED = "SET_GAME_PAUSED";

// Define a constant variable for resume functionality
export const RESUME_GAME = "RESUME_GAME";

// Define a constant variable for quit functionality
export const QUIT_GAME = "QUIT_GAME";
